import { useFragment, graphql } from "react-relay";

import { SubTodoIndicator } from "arkh/src/cross-platform/SubTodoIndicator";
import { TodoListItemFooterSubTodos_todo$key } from "./__generated__/TodoListItemFooterSubTodos_todo.graphql";

export function TodoListItemFooterSubTodos(props: {
  todo: TodoListItemFooterSubTodos_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemFooterSubTodos_todo on Todo {
        id
        subTodos {
          status
        }
      }
    `,
    props.todo
  );

  if (todo?.subTodos?.length === 0) {
    return null;
  }

  return (
    <SubTodoIndicator
      statuses={todo.subTodos?.map((subTodo) => subTodo.status) ?? []}
    />
  );
}
